export default function Title({ title, desc, children, className, as: Heading = "h2" }) {
  return (
    <div className="w-full text-center space-y-5 mb-10 lg:mb-16  ">
      <div className={`text-2xl lg:text-3xl ${className}`}>
     {children ?? <Heading> {title}</Heading>}
            </div>
      {desc && <p className="text-mute font-dana-light lg:max-w-3xl !mx-auto lg:text-lg text-center line-clamp-2 px-5">{desc}</p>}
    </div>
  );
}
